import { Decimal } from "decimal.js";
import { roundPrice } from "@/models/round-price";
interface Estimate {
  items: EstimateItem[];
  children?: Estimate[];
}

interface EstimateItem {
  id: string;
  amount: number;
  unitPrice: number;
  totalPrice: number;
  unitLoss: number;
  loss: number;
  items?: EstimateItem[];
}

/**
 * 発注額と利益率から見積額を計算する
 * @param _estimate
 * @param _profitRate
 * @returns
 */
export function estimateFromProfitRate(
  estimate: Estimate,
  profitRate: number
): Estimate {
  return {
    ...estimate,
    items: estimate.items.map(item =>
      estimateItemFromProfitRate(item, profitRate)
    )
  };
}

/**
 * 発注額と利益率から見積額を計算する
 * @param estimate
 * @param profitRate
 * @param idsSelected
 * @param numberRound
 * @param typeRound
 * @returns
 */
export function estimateRoundedFromProfitRate(
  estimate: Estimate,
  profitRate: number,
  idsSelected: Set<string>,
  numberRound: number,
  typeRound: string
): Estimate {
  return {
    ...estimate,
    items: estimate.items.map(item =>
      roundUnitPriceLowest(
        item,
        profitRate,
        idsSelected,
        numberRound,
        typeRound
      )
    ),
    children:
      (estimate.children &&
        estimate.children.map((child: Estimate) =>
          estimateRoundedFromProfitRate(
            child,
            profitRate,
            idsSelected,
            numberRound,
            typeRound
          )
        )) ||
      []
  };
}

function estimateItemFromProfitRate(
  estimateItem: EstimateItem,
  profitRate: number
): EstimateItem {
  if (estimateItem.items && estimateItem.items.length > 0) {
    const items = estimateItem.items.map(item =>
      estimateItemFromProfitRate(item, profitRate)
    );
    const unitPrice = items.reduce((s, i) => s + i.totalPrice, 0);
    return {
      ...estimateItem,
      items,
      unitPrice,
      totalPrice: unitPrice * estimateItem.amount
    };
  }

  const unitPrice = new Decimal(estimateItem.unitLoss)
    .div(new Decimal(1).minus(profitRate))
    .round()
    .toNumber();
  return {
    ...estimateItem,
    unitPrice,
    totalPrice: unitPrice * estimateItem.amount
  };
}

function roundUnitPriceLowest(
  estimateItem: EstimateItem,
  profitRate: number,
  idsSelected: Set<string>,
  numberRound: number,
  typeRound: string
): EstimateItem {
  if (estimateItem.items && estimateItem.items.length > 0) {
    const items = estimateItem.items.map(item =>
      roundUnitPriceLowest(
        item,
        profitRate,
        idsSelected,
        numberRound,
        typeRound
      )
    );
    return {
      ...estimateItem,
      items
    };
  } else {
    if (idsSelected.has(estimateItem.id.toString())) {
      const unitPrice = roundPrice(
        numberRound,
        typeRound,
        new Decimal(estimateItem.unitLoss).div(new Decimal(1).minus(profitRate))
      );
      return {
        ...estimateItem,
        unitPrice
      };
    } else {
      return {
        ...estimateItem
      };
    }
  }
}
